import SlideshowBuilder from './SlideshowBuilder';


export default SlideshowBuilder;
